export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_identity.js
// module id = 355
// module chunks = 1